export const userTypeModal = {
  title: 'About Permission',
  description: `Full control
User with "Full control" permission can access all pages, export data, update data, create admin user, etc.

Read-only
Read-only user can do anything except accessing Admin page`,
}
